module.exports = __webpack_public_path__ + "static/img/about-us-bg.e890fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/about-us-bg.png
// module id = Fimd
// module chunks = 4